/**
 * External Dependencies
 */
import 'jquery';
import Cookies from 'js-cookie';
import anime from 'animejs/lib/anime.es.js';
import * as VisibleProgress from 'dlg-mixins/js/VisibleProgress.js';

function seekProgress(ev) {
    let theanim = ev.currentTarget.animation
    theanim.seek(theanim.duration * ev.detail.instance.progress);
    if(ev.detail.instance.progress >= 0.1) {
        $(ev.currentTarget).addClass('absolute-anim-done');
    }else {
        $(ev.currentTarget).removeClass('absolute-anim-done');
    }
}

$(document).ready(() => {
    $(".toggle_menu").click(function(){
        $(".mon_menu").toggleClass("!h-screen");
    });

    $('.menu-item > a').on('click', function(ev) {
        if($(this).attr('href').substring(0, 1) == '#') {
            let target = $($(this).attr('href'));
            if(target.length) {
                console.log(target.scrollTop());
                $('html,body').animate({
                    'scrollTop': target.offset().top
                })
                $(".mon_menu").removeClass("!h-screen");     
                ev.preventDefault();
            }
        }
    });

    $('.js-anime-parallax').each(function(index, el) {
        let _this = $(el);

        el.animation = anime({
            duration: 25000,
            autoplay: false,
            targets: el,
            translateX: [0, 0],
            translateY: ['-20%', '20%'],
            translateZ: [0, 0],
            scale: ['1.20', '1.20'],
            easing: 'linear',
        });

        new VisibleProgress(el, false, 0, 0);
        el.addEventListener('progress', seekProgress);

        // VisibleProgress.triggerScroll(window);
    });

    if (Cookies.get('coupeksa_alert_dismissed') == null) {
        $('.js-coupeksa-alert').fadeIn(250);
    }
    $('.js-coupeksa-alert-close').on('click', function(ev) {
        $('.js-coupeksa-alert').fadeOut(250);
        Cookies.set('coupeksa_alert_dismissed', 'yes', { expires: 31, path: '/' });
        ev.preventDefault();
    });
});
